// extracted by mini-css-extract-plugin
var _1 = "ToDoClip__image--LL9nJ";
export { _1 as "image" }
